export default {
  process: (err, ref, transformer = null) => {
    if (err.response?.status === 422) {
      // validate error, do something
      if( ref ) {
        if (typeof transformer === 'function') {
          const transformedErrors = transformer(err.response.data.errors);
          ref.setErrors(transformedErrors);
        } else {
          ref.setErrors(err.response.data.errors);
        }
      }
      return false;
    } else {
      return Promise.reject(err)
    }
  },

  reset: (ref) => {
    ref.setErrors([])
  }
}
